<template>
    <div>
        <div class="content">
        <van-field
          is-link
          readonly
          label="证明申请"
          @click="goNav('certificationApplicationDetail')"
        />
        <van-field
          is-link
          readonly
          label="申请记录"
          @click="goNav('certificationApplicationRecords')"
        />
      </div>
    </div>
</template>
<script>
export default {
    methods:{
        goNav(destination) {
            this.$router.push({ path: destination });
        }
    }
}

</script>
<style>
</style>